export default function Sass_String() {
  return (
    <div>
      <h1>Sass String</h1>
    </div>
  );
}
